export default __webpack_public_path__ + "static/media/mun_logo.a3415166.jpg";